import {
  AtsHiringPipelinePhaseFragment,
  AtsHiringPipelineStageFragment,
} from 'generated/resources/graphql'
import { groupBy, sortBy } from 'lodash'

import i18n from 'modules/core/lib/i18n'

import { AtsHiringStageNames, UNASSIGNED_STAGE } from 'modules/ats/lib/utils/hiringStages'

export interface HiringStageWithApplicationPhases {
  id: string
  position: number
  name: AtsHiringStageNames
  label: string
  applicationPhases: AtsHiringPipelinePhaseFragment[]
}

export const groupApplicationPhasesByHiringStage = (
  hiringStages: AtsHiringPipelineStageFragment[],
  applicationPhases: AtsHiringPipelinePhaseFragment[]
): HiringStageWithApplicationPhases[] => {
  const availableStages = new Set(hiringStages.map((stage) => stage.id))

  const sortedApplicationPhases = sortBy(
    applicationPhases,
    (applicationPhase) => applicationPhase.position
  )

  const groupedPhases = groupBy(sortedApplicationPhases, (applicationPhase) => {
    if (
      applicationPhase.atsHiringStageId &&
      availableStages.has(applicationPhase.atsHiringStageId)
    ) {
      return applicationPhase.atsHiringStageId
    }

    return -1
  })

  const groupedStages: HiringStageWithApplicationPhases[] = []

  if (groupedPhases[-1]?.length) {
    groupedStages.push({
      id: '0',
      position: 0,
      name: UNASSIGNED_STAGE,
      label: i18n.t('ats.hiring_pipelines.stages.not_assigned'),
      applicationPhases: groupedPhases[-1] || [],
    })
  }

  for (const stage of hiringStages) {
    groupedStages.push({
      id: stage.id,
      position: stage.position,
      name: stage.name,
      label: stage.label,
      applicationPhases: groupedPhases[stage.id] || [],
    })
  }

  return groupedStages
}
